// Create a activity card component
import React from "react";

import Switch4 from "./Switch4.js";
import DoorLock from "./DoorLock.js";
const Device = (props) => {
  const { element, UID, Data } = props;
  console.log(element);

  const RenderDevice = ({ type }) => {
    switch (type) {
      case 10000:
        return <Switch4 element={element} UID={UID} Data={Data} />;
      case 10100:
        return <Switch4 element={element} UID={UID} Data={Data} />;
      case 5001:
        return <DoorLock element={element} UID={UID} Data={Data} />;
      default:
        return <div>Unknown</div>;
    }
  };
  return (
    <>
      <RenderDevice type={element.Type} />
    </>
  );
};

export default Device;
